/**
 * Spawner component - allows buildings to spawn units
 */

import type { UnitType } from '@/types';

export interface SpawnerComponent {
  unitType: UnitType;
  spawnInterval: number;
  spawnTimer: number;
  maxSpawns: number;
  spawned: number;
  rallyX: number | null;
  rallyZ: number | null;
}

export function createSpawner(
  unitType: UnitType,
  spawnInterval: number = 10,
  maxSpawns: number = -1
): SpawnerComponent {
  return {
    unitType,
    spawnInterval,
    spawnTimer: 0,
    maxSpawns,
    spawned: 0,
    rallyX: null,
    rallyZ: null,
  };
}
